import axios from 'axios'
import store from '@/store/index'
// create an axios instance
// let baseURL = 'http://119.23.229.41:11002/'
//let baseURL = 'http://192.168.5.50:11002/'
let baseURL = 'http://113.98.198.44:11002/'
// let baseURL = 'http://120.79.184.8:11002/'
const service = axios.create({
  //   baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: baseURL, // 生产环境
  // baseURL: 'http://120.79.184.8:11002/', // 测试环境
  timeout: 5000 // request timeout
})

// 请求次数
const requestRetryCount = 3

// request interceptor
service.interceptors.request
  .use
// config => {
//   const token = sessionStorage.getItem('access_token')
//   if (!token) {
//     config.headers.Authorization = 'Basic YW50c0NvcmU6c3Vvd2VpMjAyMg=='
//   } else {
//     config.headers.Authorization = 'Bearer' + token
//   }
//   return config
// },
// error => {
//   // do something with request error
//   console.log(error) // for debug
//   return Promise.reject(error)
// }
()

// response interceptor
service.interceptors.response.use(
  // response => {
  //   return response.data
  // },
  // error => {
  //   return Promise.reject(error)
  // }
  response => {
    // 对响应数据做些什么
    return response.data
  },
  error => {
    // // 对响应错误做些什么
    // let { config, response } = error
    // if (response) {
    //   // 请求已发出，但是服务器响应的状态码不在 2xx 范围内
    //   console.error(
    //     'Error response status: ',
    //     response.status,
    //     response.statusText
    //   )
    // } else {
    //   // 处理请求超时或没有网络连接
    //   if (!config || !requestRetryCount) {
    //     return Promise.reject(error)
    //   }
    //   config.__retryCount = config.__retryCount || 0
    //   if (config.__retryCount >= requestRetryCount) {
    //     return Promise.reject(error)
    //   }
    //   config.__retryCount += 1
    //   return new Promise(resolve => {
    //     setTimeout(() => resolve(service(config)), 2000)
    //   })
    // }
  }
)

export default service
